//App.vue



<template>

  <router-view/>
  
</template>


<script>


export default {
	name: 'App',
	data() {
		return {
			loggedInStatus: '',
			authenticated: false,
			mockAccount: {
				username: "nraboy",
				password: "password"
			}
		}
	},
	// mounted() {
	// 	if(!this.authenticated) {
	// 		this.$router.replace({ name: "login" });
	// 	}
	// },
	methods: {
		setAuthenticated(status) {
			this.authenticated = status;
		},
		logout() {
			this.authenticated = false;
		}
	}
}

</script>

<style>
/* #app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
} */

body {
	height: 100vh;
	margin: 0;
	padding: 0px;

	width: 100%;
}

#app {
	display: flex;
	height: 100%;
}

</style>
